import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { jsx as ___EmotionJSX } from "@emotion/core";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useState } from 'react';
import { createAuthClient } from '../okta';
export var AuthContext = React.createContext(undefined);
var defaultState = {
  isAuthenticated: false,
  isLoggedIn: false,
  currentUser: undefined
};
var defaultOktaConfig = {
  issuer: '',
  pkce: true,
  redirectUri: 'https://dfds.com',
  tokenManager: {
    storage: 'sessionStorage'
  }
};

var constructIssuerUrl = function constructIssuerUrl(config) {
  var authServer = config.authServer,
      applicationEnvironment = config.applicationEnvironment;
  var appAuthServer = authServer ? authServer : 'default';
  var baseUrl = applicationEnvironment === 'prod' ? '' : applicationEnvironment + '-';
  return "https://".concat(baseUrl, "accounts.dfds.com/oauth2/").concat(appAuthServer);
};

export var AuthProvider = function AuthProvider(_ref) {
  var config = _ref.config,
      children = _ref.children;

  // initially set the loading to false to insure we don't get a login dialog being flashed
  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      isLoading = _useState2[0],
      setIsLoading = _useState2[1];

  var _useState3 = useState(defaultState),
      _useState4 = _slicedToArray(_useState3, 2),
      state = _useState4[0],
      setState = _useState4[1];

  defaultOktaConfig.issuer = constructIssuerUrl(config);
  var authClient = React.useMemo(function () {
    return createAuthClient(_objectSpread({}, defaultOktaConfig, {}, config), {
      // notice: these callbacks are in the scope of the component and could access props and state if needed
      onTokenExpire: function onTokenExpire(expiredToken) {
        return console.log('token expired', expiredToken);
      },
      onTokenRenew: function onTokenRenew(_ref2) {
        var oldToken = _ref2.oldToken,
            newToken = _ref2.newToken;
        return console.log('Token renew (old, new)', oldToken, newToken);
      }
    });
  }, [config]);

  function clearState() {
    setState(defaultState);
  }

  function login(_x, _x2) {
    return _login.apply(this, arguments);
  }

  function _login() {
    _login = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee2(credentials, getWithRedirect) {
      var isAuthenticated, isLoggedIn, currentUser;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return authClient.login(credentials, getWithRedirect);

            case 2:
              _context2.next = 4;
              return authClient.isAuthenticated();

            case 4:
              isAuthenticated = _context2.sent;
              _context2.next = 7;
              return authClient.isLoggedIn();

            case 7:
              isLoggedIn = _context2.sent;

              if (isAuthenticated) {
                _context2.next = 11;
                break;
              }

              clearState();
              return _context2.abrupt("return");

            case 11:
              _context2.next = 13;
              return authClient.getUser();

            case 13:
              currentUser = _context2.sent;
              setState(_objectSpread({}, state, {
                currentUser: currentUser,
                isAuthenticated: isAuthenticated,
                isLoggedIn: isLoggedIn
              }));

            case 15:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return _login.apply(this, arguments);
  }

  function logout() {
    return _logout.apply(this, arguments);
  }

  function _logout() {
    _logout = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee3() {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return authClient.logout();

            case 2:
              clearState();

            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));
    return _logout.apply(this, arguments);
  }

  var checkAuthentication = React.useCallback(
  /*#__PURE__*/
  _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee() {
    var newState, loggedIn, isAuthenticated;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            setIsLoading(true);
            newState = {};
            _context.next = 4;
            return authClient.isLoggedIn();

          case 4:
            loggedIn = _context.sent;
            _context.next = 7;
            return authClient.isAuthenticated();

          case 7:
            _context.t0 = !_context.sent;

            if (!_context.t0) {
              _context.next = 10;
              break;
            }

            _context.t0 = loggedIn;

          case 10:
            if (!_context.t0) {
              _context.next = 19;
              break;
            }

            _context.prev = 11;
            _context.next = 14;
            return authClient.authenticate();

          case 14:
            _context.next = 19;
            break;

          case 16:
            _context.prev = 16;
            _context.t1 = _context["catch"](11);
            console.log(_context.t1);

          case 19:
            _context.next = 21;
            return authClient.isAuthenticated();

          case 21:
            isAuthenticated = _context.sent;
            newState.isAuthenticated = isAuthenticated;
            newState.isLoggedIn = loggedIn;

            if (!isAuthenticated) {
              _context.next = 30;
              break;
            }

            _context.next = 27;
            return authClient.getUser();

          case 27:
            _context.t2 = _context.sent;
            _context.next = 31;
            break;

          case 30:
            _context.t2 = undefined;

          case 31:
            newState.currentUser = _context.t2;
            setState(function (prevState) {
              return _objectSpread({}, prevState, {}, newState);
            });
            setIsLoading(false);

          case 34:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[11, 16]]);
  })), [authClient]);
  React.useEffect(function () {
    checkAuthentication();
  }, [checkAuthentication]);

  function verifyRecoveryToken(_x3) {
    return _verifyRecoveryToken.apply(this, arguments);
  }

  function _verifyRecoveryToken() {
    _verifyRecoveryToken = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee4(recoveryToken) {
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return authClient.verifyRecoveryToken(recoveryToken);

            case 2:
              return _context4.abrupt("return", _context4.sent);

            case 3:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));
    return _verifyRecoveryToken.apply(this, arguments);
  }

  var getAccessToken = authClient.getAccessToken,
      getIdToken = authClient.getIdToken,
      getSession = authClient.getSession,
      forgotPassword = authClient.forgotPassword;
  var authApi = {
    login: login,
    logout: logout,
    checkAuthentication: checkAuthentication,
    getAccessToken: getAccessToken,
    getIdToken: getIdToken,
    getSession: getSession,
    forgotPassword: forgotPassword,
    verifyRecoveryToken: verifyRecoveryToken
  };
  var issuer = config.issuer,
      clientId = config.clientId,
      applicationEnvironment = config.applicationEnvironment,
      businessArea = config.businessArea;
  return ___EmotionJSX(AuthContext.Provider, {
    value: {
      isLoading: isLoading,
      isAuthenticated: state.isAuthenticated,
      isLoggedIn: state.isLoggedIn,
      currentUser: state.currentUser,
      authApi: authApi,
      config: {
        issuer: issuer,
        clientId: clientId,
        applicationEnvironment: applicationEnvironment,
        businessArea: businessArea
      }
    }
  }, children);
};